module.exports = __webpack_public_path__ + "static/media/2.3dc5d9ea.png";